/** Ambiente em que o app está rodando (D-012). Define a faixa de aviso no topo. */
export function ambienteAtual(): 'desenvolvimento' | 'homologacao' | 'producao' {
  const valor = import.meta.env.VITE_AMBIENTE;
  return valor === 'homologacao' || valor === 'producao' ? valor : 'desenvolvimento';
}
